import { call, put } from 'redux-saga/effects';
import ForgotPasswordActions from '../redux/ForgotPasswordRedux';
import { ApiResponse } from '../services/Api';
import { api } from './api';


// attempts to send forgot password request
export function* forgotPassword(action: any) {
  const { email } = action;
  
  try {
    // make the call to the api
    const response: ApiResponse = yield call(api.forgotPassword, email);
    console.log("forgotPassword response", response);
    
    if (response.ok) {
      // dispatch successful forgot password request
      yield put(ForgotPasswordActions.forgotPasswordSuccess());
    } else {
      // dispatch failure
      yield put(ForgotPasswordActions.forgotPasswordFailure());
    }
  } catch (error) {
    // dispatch failure
    yield put(ForgotPasswordActions.forgotPasswordFailure());
  }
}